/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  PatientForm,
  PatientFormInvite,
} from '@app/modules/patient-forms/patient-forms.types';
import { EntityBaseService } from '@core/services/entityBase.service';
import { environment } from '@root/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PatientFormsService extends EntityBaseService<PatientForm> {
  private httpClient: HttpClient;

  private readonly BASE_URL = `${environment.apiUrl}/nipts`;

  private readonly ROUTES = {
    listPatientForms: 'ListNiptPatientForms',
    provisionPatientForm: 'ProvisionNiptPatientForm',
  };

  private readonly API_CONSTANTS = {
    directory: 'NiptPatientFormDirectory',
    manager: 'NiptPatientFormManager',
    patientForm: 'NiptPatientForm',
  };

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);

    this.httpClient = httpClient;
  }

  public completePatientForm(formId) {
    return this.httpClient.patch(
      `${this.BASE_URL}/patient-forms/${formId}/status/complete`,
      {}
    );
  }

  public provisionPatientForm(formData: PatientFormInvite) {
    return this.httpClient.post(`${this.BASE_URL}/patient-forms`, formData);
  }

  public provisionPatientFormUpdate(formData: PatientFormInvite) {
    return this.httpClient.put(
      `${this.BASE_URL}/patient-forms/${formData.id}`,
      formData
    );
  }

  protected getCreateEntityUrl(newEntityId: string): string {
    return '';
  }

  protected getDeleteEntityUrl(entityId: string): string {
    return '';
  }

  protected getFetchEntityUrl(entityId: string): string {
    return '';
  }

  protected getListUrl(): string {
    return `${this.BASE_URL}/patient-forms`;
  }

  protected getUpdateEntityUrl(entityId: string): string {
    return '';
  }

  protected setCreateEntityBody(
    entity: PatientForm,
    body: Partial<PatientForm>
  ) {}

  protected setUpdateEntityBody(
    entity: PatientForm,
    body: Partial<PatientForm>
  ) {}

  protected setUrlBody(run: PatientForm) {}
}
